import { useNavigate } from 'react-router-dom';
import { LessonClassesTable } from '../../../../components/Lessons/Tables/Classes/LessonClassesTable';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const LessonClassesSubpage = () => {
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  function handleNavigate(classUuid: string) {
    navigate(classUuid);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <LessonClassesTable onNavigate={handleNavigate} />
    </Page>
  );
};
